import type {NotificationEvent} from '../../../../../api/event';
import type {RenderContract} from '../../NotificationsListItemDumb/types';
import type {AsyncEventDataProvider, EventContextsMap} from '../types';

interface AsyncEventDataProviderConstructor {
  new (
    event: NotificationEvent,
    contexts: EventContextsMap,
    staticData: RenderContract,
  ): AsyncEventDataProvider;
}

const storeClassGettersByEventType = new Map<
  NotificationEvent['type'],
  () => AsyncEventDataProviderConstructor
>([
  ['course_stopped', () => require('./course_stopped').AsyncEventStore],
  [
    'membership_proposed',
    () => require('./membership_proposed').AsyncEventStore,
  ],
  ['refund_requested', () => require('./refund_requested').AsyncEventStore],
]);

export const getAsyncEventStore = (
  event: NotificationEvent,
  contexts: EventContextsMap,
  staticData: RenderContract,
) => {
  const StoreClass = storeClassGettersByEventType.get(event.type)?.();

  return StoreClass ? new StoreClass(event, contexts, staticData) : undefined;
};
